import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Workspace from '@/pages/Workspace';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

function App() {
  React.useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Workspace />} />
          <Route path="*" element={<Workspace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
